<template>
  <div class="map-container">
    <!-- Viewer -->
    <div ref="mapContainer" class="map-viewer" />

    <!-- Modules -->
    <slot />
  </div>
</template>

<script>
import L from "@/plugins/leaflet";

export default {
  props: {
    initOptions: {
      type: Object,
      default: () => ({
        center: window.config.MAP.CENTER,
        zoom: window.config.MAP.ZOOM,
        maxZoom: window.config.MAP.MAX_ZOOM,
        attributionControl: false,
        zoomControl: false
      })
    }
  },

  data() {
    return {
      loaded: false,
      map: null
    };
  },

  provide() {
    return {
      getMap: this.getMap
    };
  },

  mounted() {
    this.init();
  },

  beforeDestroy() {
    this.destroy();
  },

  methods: {
    init() {
      this.$nextTick(() => {
        this.map = new L.Map(this.$refs.mapContainer, {
          ...this.initOptions
        });

        // this.map.once('load', () => {
        //   this.loaded = true
        //   this.$emit('map-loaded')
        // })

        this.loaded = true;
        this.$emit("map-loaded");
      });
    },

    getMap(callback) {
      if (this.loaded) {
        return callback(this.map);
      } else {
        this.$once("map-loaded", () => {
          callback(this.map);
        });
      }
    },

    destroy() {
      this.map.remove();
      this.map = null;
    }
  }
};
</script>

<style>
.leaflet-container {
  background: #fff;
  outline: 0;
}
</style>

<style scoped>
.map-container {
  position: relative;
  width: 100%;
  height: 100%;
  display: flex;
  flex-flow: column;
}

.map-viewer {
  flex: 1;
  min-height: 0;
  min-width: 0;
}
</style>
